(function (angular, schoolwork12) {

    'use strict';
    var administrationToolsApp = angular.module(schoolwork12.app.administrationTools.name, [ 
    	'ui.grid', 'ui.grid.resizeColumns', 'ui.grid.pagination',
		'ui.grid.selection', 'ui.grid.exporter' ]);

		administrationToolsApp.controller(schoolwork12.app.administrationTools.controllers.administrationTools, [
        '$rootScope', '$scope', '$http', '$timeout', '$interval', '$uibModal','$location', '$state',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
		 schoolwork12.app.administrationTools.services.administrationToolsSvc,
		 schoolwork12.app.fulfillment.services.getAllSchools,
        function ($rootScope, $scope, $http, $timeout, $interval, $uibModal, $location, $state, authentication, 
        	      eventNotification, administrationToolsSvc, getSchools) {

        	console.info("In Administration Tools controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Administration Tools controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
						// valid roles for Administration Tools page
						$scope.mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
				});
			
			$scope.mainModel = {};
			// valid roles for Administration Tools
			if (authentication
					&& authentication.isAuthenticated()) {				
					$scope.mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
			};	
		   
			//User tries to navigate Away with unsaved Changes
			$scope.$parent.$on('$stateChangeStart', function(event, next, current) { 
				if($scope.forms.schoolCluster && $scope.forms.schoolCluster.$dirty){
					event.preventDefault();
					schoolClusterUnsavedChanges().result.then(function (leave) {
						if(leave){
							$scope.forms.schoolCluster.$setPristine();
							$location.url(next.url); 
						}
					})
				}
			})

            //Initialize global variables and functions
			$scope.activeView = 'none';
			$scope.isAdminToolsSearchBusy = false;
			$scope.isAdminToolSaveBusy = false;
			$scope.withdrawPerson=false;
			
			$scope.showSavedSchoolClusterMsg = false;
			$scope.showSaveErrorSchoolClusterMsg = false;
			$scope.clusterSchoolDuplicated = false;

			//errorMessages
			$scope.schoolClusterNameRequired = schoolwork12.app.administrationTools.errorMessages.schoolClusterNameRequired;
            $scope.schoolClusterAbbreRequired = schoolwork12.app.administrationTools.errorMessages.schoolClusterAbbreRequired;
            $scope.schoolClusterNameUnique = schoolwork12.app.administrationTools.errorMessages.schoolClusterNameUnique;
			$scope.schoolClusterAbbrevUnique = schoolwork12.app.administrationTools.errorMessages.schoolClusterAbbrevUnique;
			$scope.clusterSchoolDuplicatedMsg = schoolwork12.app.administrationTools.errorMessages.clusterSchoolDuplicated;
			$scope.fixAdultBadPersonIdInvalid = schoolwork12.app.administrationTools.errorMessages.fixAdultBadPersonIdInvalid
			$scope.fixAdultGoodPersonIdInvalid = schoolwork12.app.administrationTools.errorMessages.fixAdultGoodPersonIdInvalid
			

			$scope.closeAdminToolSuccessSaveMsg = function() {
                $scope.showSavedSchoolClusterMsg = false;
            }

			$scope.getOptionInfo = function () {
				$scope.isAdminToolsSearchBusy = true;

				//Reset Parent view status
				$state.go('adminTools');
				$scope.fixDupAdultToolTip = false;
				$scope.reactivateAdultToolTip = false;
				$scope.withdrawPerson = false;
				$scope.activeView = 'none';

				switch ($scope.adminTools.type) {
					case 'fixDuplicateAdutls':{
						$scope.isAdminToolsSearchBusy = false;
						$scope.fixDupAdultToolTip = true;
						$state.go('adminTools.fixAdults');
					}break;
					case 'schoolClusters':{
						getSchoolClusters();
						$scope.withdrawPerson = false;
					}break;
					case 'withdrawPerson':{
						$scope.withdrawPerson = true;
						$scope.isAdminToolsSearchBusy = false;
					}break;
					case 'reactivateAdult':{
						$scope.isAdminToolsSearchBusy = false;
						$scope.reactivateAdultToolTip = true;
						$state.go('adminTools.reactivateAdults');
					}break;
				}
			}

			$scope.schoolClusterAttributeChange = function () {
				$scope.schoolCluster.isEdited = true;
			}

			let getSchoolClusters = function() {
				$scope.forms.schoolCluster.$setPristine();
				administrationToolsSvc.getSchoolClusters(authentication.getCurrentUser().keycode).then(function (data) {
					$scope.activeView = 'showSchoolClustersTable';
					$scope.setSchoolClusters = data;
					$scope.clusterSchoolDuplicated = false;
					$scope.showSaveErrorSchoolClusterMsg = false;
					$scope.clusterSchoolDuplicated = false;
				},function(error) {
					console.error('Error when getting School Clusters...'.concat(angular.toJson(error)));
					$scope.showSaveErrorSchoolClusterMsg = true;
					$scope.adminToolSaveErrorMesg = "";
					if (error.status == 400) {
						for (var j = 0; j < error.data._errors.length; j++) {
							$scope.adminToolSaveErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
						}
					} else if (error.status == 401 || error.status == 403) {
						$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
					} else {
						$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.internalError;
					}
				})['finally'](function () {
					$scope.isAdminToolsSearchBusy = false;
				});		
			}

			let initializeSchoolClusterFormControls = function () {
				//Initializing Forms Errors
				schoolClusterformErrorInitialization();

				//initializing forms controls
				$scope.forms.schoolCluster.$setPristine();
				$scope.schoolTypeSelected = "";
				$scope.clusterConfigurationsSelected = [];
				$scope.changeSchoolTypeSelection();

				//hiding any error / success message
				$scope.clusterSchoolDuplicated = false;
				$scope.showSaveErrorSchoolClusterMsg = false;
				$scope.showSavedSchoolClusterMsg = false;
			}

			let schoolClusterformErrorInitialization = function(){
				$scope.forms.schoolCluster['schoolClusterNameInput'].$setValidity("nameRequired",true);
				$scope.forms.schoolCluster['schoolClusterNameInput'].$setValidity("nameUnique",true);
				$scope.forms.schoolCluster['schoolClusterAbbrevInput'].$setValidity("abbrevRequired",true);
				$scope.forms.schoolCluster['schoolClusterAbbrevInput'].$setValidity("abbrevUnique",true);
			}

			let validateSchoolClusterForm = function (schoolClusterToSave) {
				let result = true;
				if(schoolClusterToSave.name == null || schoolClusterToSave.name == ''){
					$scope.forms.schoolCluster['schoolClusterNameInput'].$setValidity("nameRequired",false);
					result = false;
				} 
				if(schoolClusterToSave.abbreviation == null || schoolClusterToSave.abbreviation == ''){
					$scope.forms.schoolCluster['schoolClusterAbbrevInput'].$setValidity("abbrevRequired",false);
					result = false;
				}

				return result;
			}

			$scope.showSchoolClusterForm = function (schoolCluster) {
				$scope.activeView = 'showSchoolClusterForm';
				$scope.schoolClusterBusy = true;
				initializeSchoolClusterFormControls();
				getAllSchools();
				getClusterConfigs();
				if(schoolCluster){
					$scope.schoolClusterFormType = "Edit";
					$scope.schoolCluster = angular.copy(schoolCluster);
				}else{
					$scope.schoolClusterFormType = "Create";
					$scope.schoolCluster = {
						"id": -1,
						"name": "",
						"abbreviation": "",
						"schoolsInCluster": 0,
						"status": 1,
						"isEdited": true,
						"clusterSchoolList": [],
						"clusterConfigList": []
					}
				}
			}

			$scope.cancelSchoolClusterForm = function () {
				if($scope.forms.schoolCluster.$dirty){
					var unsavedChangesPromise = schoolClusterUnsavedChanges();
					unsavedChangesPromise.result.then(function (leave) {
						if(leave){
							$scope.activeView = 'showSchoolClustersTable';
							$scope.forms.schoolCluster.$setPristine();
						}
					});
				}else{
					$scope.activeView = 'showSchoolClustersTable';
					$scope.forms.schoolCluster.$setPristine();
				}
			}

			$scope.saveSchoolCluster = function (schoolClusterToSave) {
				if(validateSchoolClusterForm(schoolClusterToSave)){
					$scope.isAdminToolSaveBusy = true;
					administrationToolsSvc.saveSchoolClusters(authentication.getCurrentUser().keycode,schoolClusterToSave)
						.then(function (data) {
							if (data) {
								getSchoolClusters();
								$scope.showSavedSchoolClusterMsg = true;
								$scope.showSaveErrorSchoolClusterMsg = false;
								$scope.clusterSchoolDuplicated = false;
							}
						},function(error) {
							console.error('Error when getting the school types and names....'.concat(angular.toJson(error)));
							$scope.showSaveErrorSchoolClusterMsg = true;
							$scope.adminToolSaveErrorMesg = "";
							if (error.status == 400) {								
								$scope.adminToolSaveErrorMesg = $scope.adminToolSaveErrorMesg + error.data;
							} else if (error.status == 401 || error.status == 403) {
								$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
							} else {
								$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.internalError;
							}

							let schoolClusterNameConstraint = (~$scope.adminToolSaveErrorMesg.indexOf("java.sql.SQLException: ORA-00001: unique constraint (SAMS.CLUSTERSNAME_UN) violated")) ? true : false;
							let schoolClusterAbbrevConstraint = (~$scope.adminToolSaveErrorMesg.indexOf("java.sql.SQLException: ORA-00001: unique constraint (SAMS.CLUSTERSABBR_UN) violated"))  ? true : false;
							let clusterSchoolDuplicated = (~$scope.adminToolSaveErrorMesg.indexOf("ORA-00001: unique constraint (SAMS.CLUSTERSCHOOL_UN) violated")) ? true : false;
							$scope.forms.schoolCluster['schoolClusterNameInput'].$setValidity("nameUnique",!schoolClusterNameConstraint);
							$scope.forms.schoolCluster['schoolClusterAbbrevInput'].$setValidity("abbrevUnique",!schoolClusterAbbrevConstraint);
							$scope.clusterSchoolDuplicated = clusterSchoolDuplicated;

						})['finally'](function () {
							$scope.isAdminToolSaveBusy = false;
						});
					
				}
			}

			$scope.changeSchoolTypeSelection = function () {
				if($scope.schoolTypeSelected != null && $scope.schoolTypeSelected !== ''){
					let temp =  $scope.schoolList[$scope.schoolTypeSelected];
					$scope.filteredSchoolList = findArrayDifference(temp,$scope.schoolCluster.clusterSchoolList,'schoolId');
				}else{
					$scope.filteredSchoolList = [];
				}
			}

			let findArrayDifference = function (array1,array2,attribute) {
				if(Array.isArray(array1) && Array.isArray(array2) && attribute != null && attribute !== ''){
					return array1.filter( a1 => array2.find( a2 => a2[attribute] == a1[attribute]) == null);
				}
			}

			let clusterConfigurationCleanUp = function () {
				$scope.clusterConfigurations = findArrayDifference($scope.setClusterConfigurations,$scope.schoolCluster.clusterConfigList,'id');
			}

			$scope.addClusterConfigurations = function () {
				if($scope.clusterConfigurationsSelected != null && $scope.clusterConfigurationsSelected.length > 0){
					$scope.clusterConfigurationsSelected.forEach(element => {
						if($scope.schoolCluster.clusterConfigList.find(x => x.id == element.id) == null){
							$scope.schoolCluster.clusterConfigList.push({
								'id': element.id,
								'description': element.description,
								'name': element.name,
								'isEdited': true,
								'status': 1,
								'isNewAdded': true
							});
							$scope.schoolClusterAttributeChange();
						}
						console.log($scope.schoolCluster.clusterConfigList);
					});
					clusterConfigurationCleanUp();
				}
			}

			$scope.addClusterSchools = function () {
				if($scope.schoolListSelected != null && $scope.schoolListSelected.length > 0){
					$scope.schoolListSelected.forEach(element => {
						if($scope.schoolCluster.clusterSchoolList.find(x => x.schoolId == element.schoolid) == null){
							$scope.schoolCluster.clusterSchoolList.push({
									"clustersId": $scope.schoolCluster.id,
									"schoolId": element.schoolId,
									"schoolName": element.name,
									"createdBy": "",
									"createDate": "",
									"isEdited": true,
									"schoolType": $scope.schoolTypeSelected,
									"status": 1,
									"isNewAdded": true
							});
							$scope.schoolClusterAttributeChange();
						}
					});
					$scope.changeSchoolTypeSelection();
				}
			}

			$scope.deleteSchoolCluster = function (index,item) {
				let deleteSchoolClusterModal = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'deleteSchoolCluster.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {                           
                            $scope.okDeleteSchoolCluster = function() {                                  
								$uibModalInstance.close(true);
                            };
                            $scope.deleteSchoolClusterMsg= "You are about to delete an existing School Cluster. Do you want to continue?";

                            $scope.cancelDeleteSchoolCluster = function() {
                                $uibModalInstance.close(false);
                            };
                        }
                    ],

				});
				
				deleteSchoolClusterModal.result.then(function (deletion) {
					if(deletion){
						item.status = 0;
						item.isEdited = true;
						$scope.saveSchoolCluster(item);
						console.log("School Cluster Object Deleted", item);
					}
				})
			}

			$scope.deleteClusterConfig = function (index,item) {
				let deteleClusterConfigModal = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'deteleClusterConfig.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {                           
                            $scope.okDeleteClusterConfig = function() {                                  
								$uibModalInstance.close(true);
                            };
                            $scope.deteleClusterConfigMsg= "You are about to delete the Cluster Configuration '" + item.name + "' from the School Cluster. Do you want to continue?";

                            $scope.cancelDeleteClusterConfig = function() {
                                $uibModalInstance.close(false);
                            };
                        }
                    ],

				});

				deteleClusterConfigModal.result.then(function (deletion) {
					if(deletion){
						if(item.isNewAdded){
							$scope.schoolCluster.clusterConfigList.splice(index,1);
						}else{
							item.status = 0;
						}
						item.isEdited = true;
						clusterConfigurationCleanUp();
						$scope.forms.schoolCluster.$setDirty();
						$scope.schoolClusterAttributeChange();
						console.log("Cluster Configuration Object Deleted", item);
					}
				})
			}

			$scope.deleteSchoolFromCluster = function (index,item) {
				let deleteSchoolFromClusterModal = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'deleteSchoolFromCluster.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {                           
                            $scope.okDeleteSchoolFromCluster = function() {                                  
								$uibModalInstance.close(true);
                            };
                            $scope.deleteSchoolFromClusterMsg= "You are about to delete the School '" + item.name + "' from the School Cluster. Do you want to continue?";

                            $scope.cancelDeleteSchoolFromCluster = function() {
                                $uibModalInstance.close(false);
                            };
                        }
                    ],

				});	

				deleteSchoolFromClusterModal.result.then(function (deletion) {
					if(deletion){
						if(item.isNewAdded){
							$scope.schoolCluster.clusterSchoolList.splice(index,1);
						}else{
							item.status = 0;
						}
						item.isEdited = true;
						$scope.changeSchoolTypeSelection();
						$scope.forms.schoolCluster.$setDirty();
						$scope.schoolClusterAttributeChange();
						console.log("School Object Deleted from School Cluster", item);
					}
				})
			}

			let schoolClusterUnsavedChanges = function () {
				let operation = $scope.schoolClusterFormType === 'Edit' ? 'Editing' : 'Creating';
				let schoolClusterUnsavedChangesModal = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'schoolClusterUnsavedChanges.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {                           
                            $scope.discardSchoolClusterChanges = function() {                                  
								$uibModalInstance.close(true);
                            };
                            $scope.schoolClusterUnsavedChangesMsg= "You have began " + operation + " a School Cluster and this have unsaved changes. Do you want to continue without saving the changes?";

                            $scope.remainSchoolClusterChanges = function() {
                                $uibModalInstance.close(false);
                            };
                        }
                    ],
				});	

				return schoolClusterUnsavedChangesModal;
			}

			var getAllSchools = function () {
				return getSchools.getAllSchoolsList(authentication.getCurrentUser().keycode)
						.then(function (data) {
							if (data) {
								$scope.schoolList = data
								$scope.schoolTypeList = Object.keys(data);
							}
						},function(error) {
							console.error('Error when getting the school types and names....'.concat(angular.toJson(error)));
							$scope.showSaveErrorSchoolClusterMsg = true;
							$scope.adminToolSaveErrorMesg = "";
							if (error.status == 400) {
								for (var j = 0; j < error.data._errors.length; j++) {
									$scope.adminToolSaveErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
								}
							} else if (error.status == 401 || error.status == 403) {
								$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
							} else {
								$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.internalError;
							}
						})['finally'](function () {
							$scope.schoolClusterBusy = false;
						});
			}

			var getClusterConfigs = function () {
				return administrationToolsSvc.getClusterConfigurations(authentication.getCurrentUser().keycode).then(function (data) {
					if(data){
						$scope.setClusterConfigurations = data;
						$scope.clusterConfigurations = angular.copy($scope.setClusterConfigurations);
						clusterConfigurationCleanUp();
					}
				},function(error) {
					console.error('Error when getting Cluster Configurations...'.concat(angular.toJson(error)));
					$scope.showSaveErrorSchoolClusterMsg = true;
					$scope.adminToolSaveErrorMesg = "";
					if (error.status == 400) {
						for (var j = 0; j < error.data._errors.length; j++) {
							$scope.adminToolSaveErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
						}
					} else if (error.status == 401 || error.status == 403) {
						$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
					} else {
						$scope.adminToolSaveErrorMesg = schoolwork12.app.errorMessages.internalError;
					}
				});
			}	
		}
	]);

}(angular, schoolwork12));